import type { DocMigration } from "../docMigration";

const catalogFieldsIOfSettingsType: {
  [settingsType: string]: { fieldName: string; catalogItemType: string }[];
} = {
  ["ANNOTATION_CATALOG_SETTINGS"]: [{ fieldName: "annotationTemplates", catalogItemType: "ANNOTATION_TEMPLATE" }],
  ["CASEWORK_CATALOG_SETTINGS"]: [{ fieldName: "caseworkTypes", catalogItemType: "CASEWORK_DESCRIPTOR" }],
  ["DOOR_CATALOG_SETTINGS"]: [{ fieldName: "doorTypes", catalogItemType: "DOOR_DESCRIPTOR" }],
  ["WALL_CATALOG_SETTINGS"]: [
    { fieldName: "wallTypes", catalogItemType: "WALL_TYPE" },
    { fieldName: "wallMaterials", catalogItemType: "STRUCTURAL_MATERIAL" },
  ],
  ["DATUM_CATALOG_SETTINGS"]: [{ fieldName: "datums", catalogItemType: "DATUM" }],
  ["FLOOR_CATALOG_SETTINGS"]: [
    { fieldName: "floorAssemblies", catalogItemType: "FLOOR_ASSEMBLY_COMPONENTS" },
    { fieldName: "floorComponents", catalogItemType: "FLOOR_COMPONENT" },
    { fieldName: "structuralFloorMaterial", catalogItemType: "STRUCTURAL_MATERIAL" },
  ],
  ["STAIR_CATALOG_SETTINGS"]: [{ fieldName: "stairSettingsTable", catalogItemType: "STAIR_SETTING" }],
  ["COLUMN_CATALOG_SETTINGS"]: [{ fieldName: "columnTable", catalogItemType: "COLUMN_DESCRIPTOR" }],
  ["WINDOW_CATALOG_SETTINGS"]: [{ fieldName: "windowTypes", catalogItemType: "WINDOW_DESCRIPTOR" }],
  ["DRAWING_CATALOG_SETTINGS"]: [{ fieldName: "drawings", catalogItemType: "DRAWING" }],
  ["PROFILE_CATALOG_SETTINGS"]: [{ fieldName: "profileTable", catalogItemType: "PROFILE_EXTRUSION_DESCRIPTOR" }],
  ["RAILING_CATALOG_SETTINGS"]: [{ fieldName: "railingSettingsTable", catalogItemType: "RAILING_SETTING" }],
  ["FOUNDATION_CATALOG_SETTINGS"]: [
    { fieldName: "foundationAssemblies", catalogItemType: "FOUNDATION_ASSEMBLY_COMPONENTS" },
    { fieldName: "foundationComponents", catalogItemType: "FOUNDATION_COMPONENT" },
  ],
  ["ELECTRICAL_ITEM_CATALOG_SETTINGS"]: [{ fieldName: "loadTypes", catalogItemType: "LOAD_DESCRIPTOR" }],
  ["INTERIOR_PROP_SETTINGS"]: [{ fieldName: "propTypes", catalogItemType: "PROP_ATTRIBUTES" }],
  ["EXTERIOR_PROP_SETTINGS"]: [{ fieldName: "propTypes", catalogItemType: "PROP_ATTRIBUTES" }],
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_283: DocMigration = {
  maxSchemaVersion: "0.0.283",
  description: "Add a catalog item type to all catalog item tables",
  apply(json: any): any {
    for (const id in json.settings) {
      const settings = json.settings[id];
      const fields = catalogFieldsIOfSettingsType[settings.type];
      if (!fields) {
        continue;
      }
      for (const fieldDesc of fields) {
        const table = settings[fieldDesc.fieldName];
        for (const id in table) {
          table[id].catalogItemType = fieldDesc.catalogItemType;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_283;
